module.exports = __webpack_public_path__ + "static/media/cc-apple-pay.bde206c5.svg";